<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { debounce } from "../../../state/helpers";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      moment,
      id: "",
      searchData: debounce(() => {
        this.getPendingRequests();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "ID",
        },
        {
          key: "users",
          sortable: true,
          label: "User",
        },
        {
          key: "bank_name",
          sortable: true,
          label: "Bank Name",
        },
        {
          key: "account_holder_name",
          sortable: true,
          label: "Account Holder Name",
        },
        {
          key: "ifsc_code",
          sortable: true,
          label: "IFSC Code",
        },
        {
          key: "amount",
          sortable: true,
          label: "Amount",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {},
  computed: {
    ...mapGetters("walletWithdrawal", [
      "getAllPendingRequest",
      "loading",
      "pendingRequestCount",
      "pagination",
    ]),
  },
  mounted() {
    this.getPendingRequests();
  },
  methods: {
    ...mapActions("walletWithdrawal", ["getPendingRequest", "requestStatusChange"]),
    getPendingRequests(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getPendingRequest(filters);
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getPendingRequests();
    },
    onStatusChange(value, withdrawal_id, value_text) {
      if (confirm("Are You Sure to " + value_text + " #" + withdrawal_id + " Request")) {
        var data = {
          id: withdrawal_id,
          status: value,
        };
        this.requestStatusChange(data);
      }
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <!-- profile Info Start -->
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Pending Request ({{ pendingRequestCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllPendingRequest"
                  :fields="fields"
                  :busy="loading"
                  class="pending-table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(users)="items">
                    {{ items.item.users ? items.item.users : "" }}
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-dropdown
                      id="dropdown-dropright"
                      dropright
                      text="Drop-Right"
                      variant="primary"
                      size="sm"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template #button-content>
                        &#xFE19;<span class="sr-only">Menu</span>
                      </template>
                      <b-dropdown-item
                        @click="onStatusChange('1', items.item.id, 'Approve')"
                        >Approve</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="onStatusChange('2', items.item.id, 'Decline')"
                        >Decline</b-dropdown-item
                      >
                    </b-dropdown>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllPendingRequest.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Pending Request Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getPendingRequests"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- profile Info End -->
      </form>
    </div>
  </div>
</template>
<style>
.pending-table-class {
  table-layout: fixed;
}
.pending-table-class th:first-child {
  width: 50px;
}
.pending-table-class th:nth-child(2n) {
  width: 150px;
}
.pending-table-class th:nth-child(3n) {
  width: 120px;
}
.pending-table-class th:nth-child(4n) {
  width: 150px;
}
.pending-table-class th:nth-child(5n) {
  width: 100px;
}
.pending-table-class th:nth-child(6n) {
  width: 150px;
}
.pending-table-class th:nth-child(7n) {
  width: 150px;
}
</style>
